import { AppHelper } from "../appHelper"
import { CommonApp } from "../core/components/commonApp";
import { NotificationHelper } from "../core/util/notificationHelper";
import { CRTemplateProps } from "./crTemplate";
import React from "react";
export default class PlannedReports extends React.Component<CRTemplateProps, any> {
    common = new AppHelper();
    notificationHelper: NotificationHelper = new NotificationHelper();
    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
    }

    save = (closeAfterSave) => {
    }

    handleFieldChange = (field, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange({ model: "dummy" }, value, dataItem);
    }

    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
}